/**
 * Feed-level domain models.
 */
import type { FeedPost } from './post';

export type FeedTab = 'trending' | 'wlb' | string;

export interface FeedPage {
  data: FeedPost[];
  hasNextPage: boolean;
  page: number;
}

/** Client-facing feed filter params (mapped to FilterPosts API by feedService). */
export interface FeedFilterParams {
  isAllPost?: boolean;
  gender?: number | null;
  ageFrom?: number | null;
  ageTo?: number | null;
  minWeight?: number | null;
  maxWeight?: number | null;
  wantToLose?: number | null;
  targetScaleUnit?: number;
  weightScaleUnit?: number;
  country?: number;
  countries?: string | null;
  filterOption?: string | null;
  startIndex?: number;
  pageSize?: number;
}

export const DEFAULT_FEED_FILTER_PARAMS: FeedFilterParams = {
  isAllPost: true,
  filterOption: null,
  gender: null,
  ageFrom: null,
  ageTo: null,
  minWeight: null,
  maxWeight: null,
  wantToLose: null,
  countries: null,
  weightScaleUnit: 2,
  targetScaleUnit: 2,
};

export interface GetUserPostsRequest {
  userId: number;
  startIndex: number;
  pageSize: number;
  action: string;
  timezoneOffset?: number;
}

export interface ApiFeedPost {
  postId: number;
  userId: number;
  profileUserGuid: string;
  userName: string;
  firstName?: string | null;
  userPhoto: string;
  postDate: string;
  contentTypeName: string;
  contentTypeFor: string;
  commentCount: number;
  reactedCount: number;
  isReacted: number;
  reactionName: string;
  url: string;
  isBuddy: number;
  isAIAgent: boolean;
  title: string;
  bodyText: string;
  currentWeight: number;
  scaleUnitWeightName: string;
  hashTags: string[];
  totalShares: number;
  allowComments: boolean;
  allowShare: boolean;
  invited: boolean;
  postVisibility: number;
  photoAlbum: string[];
  taggedUsers: any[];
}

export interface GetUserPostsResponse {
  statusCode?: number;
  success?: boolean;
  message?: string;
  feeds?: ApiFeedPost[];
}
